<app-edit-currency-dlg [header]="dlgHeader" [(display)]="displayNC"
                       [currencyRate]="newCurrency" [closeOnConfirm]="false" [saveError]="saveError" [saving]="saving" (displayChange)="onCurrencyDialogClose($event)" (currRateEntry)="onNewCurrencySelect($event)">

</app-edit-currency-dlg>
<div class="field">
  <label *ngIf="showLabel" for="CurrencySelectorDd" class="do-not-wrap-text">{{labelKey}}</label>
  <div class="p-inputgroup">
    <p-button icon="pi pi-pencil" styleClass="p-button-warning mr-1" (onClick)="onCategoryEditButton($event)" [disabled]="!isThereSelection || !canManageCurrency"
            pTooltip="Редактировать валюту/курс" tooltipPosition="top" *ngIf="doShowEditButton"></p-button>
    <p-dropdown id="CurrencySelectorDd"
                [options]="_currList"
                optionLabel="CURSTR"
                [(ngModel)]="_selectedCurrency"
                placeholder="Выбор валюты... {{_selectedCurrency}}"
                filterPlaceholder="Поиск..."
                [filter]="true"
                filterBy="CURSTR"
                [disabled]="_disabled"
                [virtualScroll]="true"
                [virtualScrollItemSize]="31"
                (onChange)="onChangeCS($event)"
                class="p-dropdown-filter"
                ></p-dropdown>
    <p-button icon="pi pi-chart-line" styleClass="p-button-success ml-1" (onClick)="onRateAddButton($event)" [disabled]="!isThereSelection || !canManageCurrency"
            pTooltip="Добавить курс" tooltipPosition="top" *ngIf="doShowAddRateButton"></p-button>
    <p-button icon="pi pi-plus" styleClass="p-button-success ml-1" (onClick)="onCurrencyAddButton($event)" [disabled]="!canManageCurrency"
            pTooltip="Добавить новую валюту" tooltipPosition="top" *ngIf="doShowAddCurrencyButton"></p-button>
  </div>
</div>
